/* @flow */

export { openBridge, linkUrl, isBridge, needsBridge, needsBridgeForBrowser, hasBridge,
    needsBridgeForWin, needsBridgeForDomain, openTunnelToOpener, destroyBridges } from './index';



// WEBPACK FOOTER //
// ./src/bridge/interface.js